import {DownloadsRegisterDTO} from "./DownloadsRegisterDTO";

export type DownloadsRegisterProps = {
	id:        string
	userID:    string    
	userName:  string    
	userEmail: string    
	clinic:    string    
	date:      Date 
	ipAdress:  string    
	browser:   string    
	doc:       string    
	codeBA:    string    
}



export class DownloadsRegister {
	_id:        string
	_userID:    string    
	_userName:  string    
	_userEmail: string    
	_clinic:    string    
	_date:      Date 
	_ipAdress:  string    
	_browser:   string    
	_doc:       string    
	_codeBA:    string    


  constructor(p: DownloadsRegisterProps) {
    this._id = p.id
    this._userID = p.userID
    this._userName = p.userName
    this._userEmail = p.userEmail
    this._clinic = p.clinic
    this._date = p.date
    this._ipAdress = p.ipAdress
    this._browser = p.browser
    this._doc = p.doc
    this._codeBA = p.codeBA
    
    
    
    

  }

  set id(value: string){
    this._id = value
  }

	set userID(value: string){
    this._userID = value    
  }    
	set userName(value: string){
    this._userName = value  
  }    
	set userEmail(value: string){
    this._userEmail = value 
  }    
	set clinic(value: string){
    this._clinic = value    
  }    
	set date(value: Date){
    this._date = value      
  } 
	set ipAdress(value: string){
    this._ipAdress = value  
  }    
	set browser(value: string){
    this._browser = value   
  }    
	set doc(value: string){
    this._doc = value       
  }    
	set codeBA(value: string){
    this._codeBA = value    
  }   

  toDTO(): DownloadsRegisterDTO {
    return {
      id: this.id,
      userID:    this.userID,
      userName:     this.userName,
      userEmail:     this.userEmail,
      clinic:     this.clinic,
      date:     this.date,
      ipAdress:     this.ipAdress,
      browser:     this.browser,
      doc:     this.doc,
      codeBA:     this.codeBA, 
      
      
      
      
      
      
      
      
    }
  }

}

export interface DownloadsRegisterQuery {
  id: string
  ids: string[]
  creatorID: string
  name: string
  language: string
}


export function toModel(f: DownloadsRegisterDTO): DownloadsRegister {
  return new DownloadsRegister(f)
}